import {ValueObject} from '@s-ui/domain'

import {AssistantChatContextAggregate} from '../Aggregates/AssistantChatContextAggregate.js'
import {AssistantChatPageTypeValueObject} from '../ValueObjects/AssistantChatPageTypeValueObject.js'

export class StartAssistantNewChatRequest extends ValueObject {
  #text
  #context

  constructor({text, context}) {
    super()
    this.#text = text
    this.#context = context
  }

  static create({
    text,
    context: {
      page: {type, adId}
    }
  }) {
    return new StartAssistantNewChatRequest({
      text,
      context: AssistantChatContextAggregate.create({
        pageType: AssistantChatPageTypeValueObject.create({type}),
        adId
      })
    })
  }

  get text() {
    return this.#text
  }

  get context() {
    return this.#context
  }
}
